import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-my-course-route.tsx
var LazyMyCourseRoute = lazy(() => import("./my-course-route-cidPQxtC.js").then((n) => n.n).then((module) => ({ default: module.MyCourseRoute })));
function MyCourseRoute({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "index-route" }),
		children: /* @__PURE__ */ jsx(LazyMyCourseRoute, { ...props })
	});
}
var useMyCourseRoute = () => {
	return useMemo(() => ({ "my-course-route": { component: MyCourseRoute } }), []);
};
//#endregion
export { useMyCourseRoute };
